// Instagram's in-app browser doesn't reliably hand script-initiated `tel:` navigations
// (e.g. `window.location.href = "tel:..."` after an await) over to the phone app.
export const isInstagramInAppBrowser = () =>
  typeof navigator !== "undefined" && /\bInstagram\b/i.test(navigator.userAgent);
